/* ヒーロー横スクロールバナー：自動スクロール＋手動ボタン＋ドット */
(function () {
  function initBanner(wrap) {
    var scroller = wrap.querySelector('.js-banner-scroll');
    var items = wrap.querySelectorAll('.p-home-banner-scroll__item');
    var prev = wrap.querySelector('.js-banner-prev');
    var next = wrap.querySelector('.js-banner-next');
    var dotsWrap = wrap.querySelector('.js-banner-dots');
    var count = items.length;
    if (!scroller || count <= 1) return;

    var autoplayMs = parseInt(wrap.getAttribute('data-autoplay'), 10) || 5000;
    var timer = null;

    function slideW() { return scroller.clientWidth; }
    function current() { return Math.round(scroller.scrollLeft / slideW()); }
    function goTo(i) {
      var idx = ((i % count) + count) % count;
      scroller.scrollTo({ left: idx * slideW(), behavior: 'smooth' });
    }

    // ドット生成
    var dots = [];
    if (dotsWrap) {
      for (var d = 0; d < count; d++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'p-home-banner-scroll__dot';
        dot.setAttribute('aria-label', (d + 1) + '番目のバナーへ');
        (function (idx) {
          dot.addEventListener('click', function () { goTo(idx); restart(); });
        })(d);
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }
    function updateDots() {
      var c = current();
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === c);
      }
    }

    // 手動ボタン
    if (next) next.addEventListener('click', function () { goTo(current() + 1); restart(); });
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); restart(); });

    // スクロール位置に応じてドット更新
    var rafPending = false;
    scroller.addEventListener('scroll', function () {
      if (rafPending) return;
      rafPending = true;
      window.requestAnimationFrame(function () { updateDots(); rafPending = false; });
    }, { passive: true });

    // 自動スクロール
    function start() {
      stop();
      timer = window.setInterval(function () {
        if (current() >= count - 1) { goTo(0); } else { goTo(current() + 1); }
      }, autoplayMs);
    }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function restart() { start(); }

    // 操作中は一時停止
    wrap.addEventListener('mouseenter', stop);
    wrap.addEventListener('mouseleave', start);
    wrap.addEventListener('touchstart', stop, { passive: true });
    wrap.addEventListener('touchend', start, { passive: true });

    updateDots();
    start();
  }

  function init() {
    var wraps = document.querySelectorAll('.js-banner');
    for (var i = 0; i < wraps.length; i++) initBanner(wraps[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
